import { SkillTranslations } from './types';

const baseLanguage = (locale: string): string =>
  locale.split(/[-_]/)[0].toLowerCase();

const isEnglish = (locale: string): boolean => baseLanguage(locale) === 'en';

export type ResolvedSkillName = {
  text: string;
  isFallback: boolean;
};

/**
 * Resolve the name to show for a locale from the canonical English base name
 * plus its per-language translations. Falls back to the base name when the
 * locale has no translation; `isFallback` flags that a non-English viewer is
 * seeing the English base name instead of a translation.
 */
export const resolveSkillName = (
  baseName: string,
  translations: SkillTranslations,
  locale: string,
): ResolvedSkillName => {
  const match =
    translations[baseLanguage(locale) as keyof SkillTranslations] || null;

  return {
    text: match ?? baseName,
    isFallback: !isEnglish(locale) && match === null,
  };
};
